import { render, staticRenderFns } from "./SendLinkModal.vue?vue&type=template&id=08a456a0&scoped=true&"
import script from "./SendLinkModal.vue?vue&type=script&lang=js&"
export * from "./SendLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./SendLinkModal.vue?vue&type=style&index=0&id=08a456a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a456a0",
  null
  
)

export default component.exports